export var TerrainType;
(function (TerrainType) {
    TerrainType["Road"] = "road";
    TerrainType["Grass"] = "grass";
    TerrainType["Gravel"] = "gravel";
    TerrainType["Wall"] = "wall";
    TerrainType["Unknown"] = "unknown";
})(TerrainType || (TerrainType = {}));
export const FRESH_TIRE_HEALTH = {
    frontLeft: 100,
    frontRight: 100,
    rearLeft: 100,
    rearRight: 100,
};
